import React from 'react';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import WalletRoutes from './Routes';
import './App.css';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: !!navigator.userAgent.match(/iPad/i) ? 600 : 900,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <HashRouter>
          <WalletRoutes />
        </HashRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;